export default __webpack_public_path__ + "static/logo-3d00a10fb6bc0b8276dff0e383a41741.jpg";